$(function () {


    $('[js-schedule-filter]').each(function () {
        const $filter = $(this);
        const $timetable = $('[js-schedule-timetable]');
        const API_URL = $filter.data('url') + '?ajax=1';

        const masterFilters = {};
       
        let $filters;
        let request;


        const refind = function () {

            $('[js-selectus]').each(function () {
                if (!$(this).siblings('.selectus-input').length) {
                    $(this).selectus();
                }
            });

            $filters = $filter.find('input[type="checkbox"], input[type="radio"], select');
            $filters.off('.schedule').on('change.schedule', function () {
                load();
                clickHeaderDay();
            });

            $('.schedule-filter__footer-button_reset').off('.schedule').on('click.schedule', function (e) {
                e.preventDefault();
                load(true, true);
            });

            // Переключение клуба
            $('[js-schedule-club-current]').on('click', function (e) {
                e.stopPropagation();
                $(this).parent().addClass('schedule-select_active');
                $('.schedule-select__list').show();
            });


            $('[js-schedule-choice]').on('click', function () {
                $('.schedule-select__list').hide();
                $('[js-schedule-switch]').removeClass('schedule-select_active');
                var CurrentClub = $('[js-schedule-club-current]').text().trim();
                var SelectClub = $(this).text().trim();

                $('[js-schedule-choice]').removeClass('is-active');
                $(this).addClass('is-active');

                if (CurrentClub !== SelectClub) {
                    $('[js-schedule-club-current-text]').text(SelectClub);
                    var select = $(this).detach();
                    $('.schedule-select__list').prepend(select)
                }

                load(true);
            });


            $('body').on('click', function () {
                $('[js-schedule-switch-list]').hide();
                $('[js-schedule-switch]').removeClass('schedule-select_active')
            });

        };

        const rebind = function(){
            $timetable.find('[js-schedule-message]').each(function(){
                var $root = $(this);
                var $items = $root.find('[js-schedule-message-item]');
                var i;

                if ($items.length > 3) {
                    $items.addClass('schedule-message__row_hidden');

                    for (i = 0; i < 3; i++) {
                        $items.eq(i).removeClass('schedule-message__row_hidden');
                    }

                    var $footer = $('<div class="schedule-message__footer"><div js-schedule-message-arrow class="schedule-message__arrow"></div></div>');
                    $root.append($footer);
                    $footer.find('[js-schedule-message-arrow]').on('click', function () {
                        $(this).toggleClass('schedule-message__arrow_rotate');
                        $('.schedule-message__row_hidden').toggle();
                    })

                }
            });
        };

        const buildQuery = function (reset) {
            const data = {};
            const filters = $.extend({}, masterFilters, reset ? {} : $filters.serializeJSON());

            filters.club = $('[js-schedule-choice].is-active').data('id');

            if (filters.service && filters.service.length) {
                data.s = filters.service;
            }

            if (filters.servicePaid && filters.servicePaid.length) {
                data.p = filters.servicePaid;
            }

            if (filters.time && filters.time.length) {
                data.t = filters.time;
            }

            if (filters.type && filters.type.length) {
                data.type = filters.type;
            }

            if (filters.age && filters.age.length) {
                data.age = filters.age;
            }

            if (filters.date && filters.date.length) {
                data.d = filters.date;
            }

            if (filters.direction && filters.direction.length) {
                data.dir = filters.direction;
            }

            if (+filters.club) {
                data.c = +filters.club;
            }

            return data;
        };

        const buildLocation = function (query) {
            if (window.history && window.history.pushState) {
                let param = $.param(query);
                history.replaceState(null, '', param ? ('?' + param) : document.location.pathname);
            }
        };

        const load = function (full, reset,) {
            if (request) {
                request.abort();
            }

            let $animationStack = $timetable;

            if (full) {
                $animationStack = $animationStack.add($filter);
            }

            $animationStack.stop().animate({opacity: .4}, 500);

            const query = buildQuery(reset);

            request = $.ajax({
                url: API_URL,
                dataType: 'json',
                type: 'post',
                data: $.extend({}, query, {full: full}),
                success: function (response) {
                    if (response.filter) {
                        $filter.html($(response.filter).html());
                        refind();
                    }
                    if (response.timetable) {
                        $timetable.html($(response.timetable).html());
                        rebind();
                    }
                },
                complete: function () {
                    $animationStack.stop().animate({opacity: 1}, 300);
                    if (!$('[js-header-day-active]').length) {
                        updateTable();
                    }

                    clickHeaderDay();
                }
            });

            buildLocation(query);

        };

        masterFilters.date = $filter.data('date');
        refind();
        rebind();
        buildLocation(buildQuery());


        // start tab
        let currentDay;

        function checkEmpty() {
            var $rows = $('[js-column-day]').closest('.schedule-table__main-row');
            $rows.removeClass('schedule-table__main-row_even schedule-table__main-row_hidden-empty');
            if ($(window).width() <= 850) {
                $rows.each(function () {
                    var $row = $(this);
                    if (!$row.find('.schedule-column_select .schedule-lesson').length) {
                        $row.addClass('schedule-table__main-row_hidden-empty');
                    }
                });
                $rows.filter(':not(.schedule-table__main-row_hidden-empty)').filter(function (i) {
                    return (i + 1) % 2 == 0;
                }).addClass('schedule-table__main-row_even')
            }
            else {
                return false
            }
        }

        checkEmpty();
        $(window).resize(function () {
            checkEmpty();
            if ($(window).width() >= 850) {
                $('[js-header-day]').removeClass('schedule-column__cell_header-active');
                $('[js-header-day-active]').addClass('schedule-column__cell_header-active');
            }
            else {
                if (currentDay) {
                    $('[js-header-day]').removeClass('schedule-column__cell_header-active');
                    $('[js-header-day=' + currentDay + ']').addClass('schedule-column__cell_header-active');
                }
            }
        });

        const clickHeaderDay = () => {
            $('[js-header-day]').on('click', function () {
                if ($(window).width() >= 850) {
                    return false
                }
                $('[js-header-day]').removeClass('schedule-column__cell_header-active');

                $(this).addClass('schedule-column__cell_header-active');

                var numberDay = $(this).attr('js-header-day');

                currentDay = $(this).attr('js-header-day');

                $('[js-column-day]').removeClass('schedule-column_select').filter('[js-column-day=' + numberDay + ']').addClass('schedule-column_select');

                checkEmpty()
            });
        };

        clickHeaderDay();

        // Неделя, где нет активного дня
        const defaultWeek = () => {
            $('[js-header-day="1"]').addClass('schedule-column__cell_header-select schedule-column__cell_header-active');

            $('[js-column-day="1"]').each(function (i) {
                var $columnDay = $(this);
                if ($columnDay.find('.schedule-lesson').length > 0) {
                    $columnDay.addClass('schedule-column_select')
                }
                else {
                    $columnDay.closest('')
                }
            })
        };

        const updateTable = () => {
            defaultWeek();
            checkEmpty();
            clickHeaderDay();
        };
        if (!$('[js-header-day-active]').length) {
            updateTable();
        }
        //end tab


        // Переключение по неделям
        $(document).on('click', '.schedule-switch__next, .schedule-switch__prev', function (e) {
            e.preventDefault();
            masterFilters.date = $(this).data('date');
            load(true);
        });

    });
});